import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';
import TablePagination from '@mui/material/TablePagination';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';

export default function CustomTableFinance(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const theme = useTheme();
  const style = theme.palette;

  const getDate = (value) => {
    const cleanValue = value?.replace(/(\d+)(st|nd|rd|th)/, '$1');
    const event = new Date(cleanValue);
    
    if (isNaN(event.getTime())) return value;
    const locale = 'fa-IR';
    
    if (locale === 'fa-IR') {
      const arr = ['دی', 'بهمن', 'اسفند', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر'];
      const convertmonths = ['جدی', 'دلو', 'حوت', 'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس'];

      const getMonth = event.toLocaleDateString(locale, { month: 'long' });
      const currentDate = event.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
      const getIndMonth = arr.indexOf(getMonth);
      
      return currentDate.replace(getMonth, convertmonths[getIndMonth]);
    }

    return event.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Calculate the sum of Payments
  const totalPayment = props.data?.reduce((total, row) => {
    const payment = parseFloat(row.Payment) || 0;
    return total + payment;
  }, 0);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handle delete Srn
  const handleDelete = (rowId) => {
  const confirmed = window.confirm("ایا غواړئ چې دا ډیلیټ غواړئ؟");
  if (confirmed && props.onDelete) {
    props.onDelete(rowId);
  }
};


  // Get the columns to display
  const columns = props.data && props.data[0] ? Object.keys(props.data[0]) : [];
  
  // Add 'Srn' column if delete functionality is enabled
  if (props.onDelete && !columns.includes('Srn')) {
    columns.push('Srn');
  }

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 515 }} aria-label="caption table">
          <TableHead>
            <TableRow sx={{ background: style.primary.main }} id="thead">
              {columns.map((key) => (
                <TableCell key={key} sx={{ color: style.sidemenutext.color }}>
                  {key === 'Month' ? 'Month' : 
                   key === 'roll' ? 'Roll Num.' : 
                   key === 'Srn' ? 'Srn.' : 
                   key === 'Date' ? 'Date' : 
                   key === 'Fees' ? 'Fees' : 
                   key === 'Discount' ? 'Discount' :
                   key === 'StudentSrn' ? 'Roll Number' :
                   key === 'StartDate' ? 'Start Date' :
                   key === 'Comments' ? 'Comments' : 
                   key === 'Payment' ? 'Payment' : 
                   key === 'paidFees' ? 'Paid Fees' :
                   key === 'Description' ? 'Description' :
                   key === 'Dues' ? 'Dues' :
                   key === 'Paid Amount' ? 'Paid Amount' :
                   key === 'NamePashto' ? 'Name' : 
                   key === 'FNamePashto' ? 'Father Name' : 
                   key === 'TellNo1' ? 'Mobile' :
                   key === 'Ammount' ? 'Amount'   : null}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data &&
              props.data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, ind) => (
                  row.Description === 'Total' ? (
                    <TableRow key={`total-${ind}`}>
                      {Object.values(row).map((value, index) => (
                        <TableCell key={`total-cell-${index}`}><b>{value}</b></TableCell>
                      ))}
                      {props.onDelete && <TableCell></TableCell>}
                      <TableCell>Delete</TableCell>
                    </TableRow>
                  ) : (
                    <TableRow key={`row-${ind}`}>
                      {Object.entries(row).map(([key, value], index) => (
                        <TableCell key={`cell-${index}`}>
                          {key === 'Date' ? (
                            <>
                              <span style={{ fontSize: '14px' }}>{getDate(value)}</span>
                              <br />
                              {value}
                            </>
                          ) : value}
                        </TableCell>
                      ))}
                      {/* {props.onDelete && ( */}
                        <TableCell>
                          <Tooltip title="Delete">
                            <IconButton 
                              aria-label="delete" 
                              onClick={() => handleDelete(row.Srn || row.id || ind)}
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      {/* )} */}
                    </TableRow>
                  )
                ))}

            {props.data && props.data.some(row => 'Payment' in row) && (
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell colSpan={columns.length - 1} align="right">
                  <b>Total:</b>
                </TableCell>
                <TableCell>
                  <b>{totalPayment?.toFixed(2)}</b>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={props.data ? props.data.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}